<template>
    <div>    
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Document Type {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Document Type - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Assign IR Resolution Code - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy || "System" }} | {{inputCreatedAt | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy || "System" }} | {{inputUpdatedAt | dateFilter}} 
            </b-tab>
        </b-tabs>
        
            <form id="form-proper">
                <a-spin :spinning="spinning">
                <div v-if="customFormMode == 1" v-show="showDetails">
                    <!-- <base-input label="Resolution" required>
                        <div class="form-group row">
                            <div class="col-sm-6">
                                <input type="text" class="form-control" v-model="documentTypeName" disabled>
                            </div>
                            <div class="col-sm-6">
                                <autocomplete
                                    ref="autocomplete"
                                    placeholder="Search"
                                    :source="documentTypeEndpoint"
                                    input-class="form-control"
                                    results-property="data"
                                    :results-display="formattedDisplay"
                                    :request-headers="authHeaders"
                                    @selected="getDocumentType">
                                </autocomplete>
                            </div>
                        </div>
                    </base-input> -->
                    <base-input alternative="" label="Resolution Code" placeholder="" v-model="document_type.resolution_code" input-classes="form-control" required/>
                    <hr>
                    <base-input alternative="" label="Trans Code" disabled placeholder="" v-model="document_type.trans_code" input-classes="form-control" required/>
                    <base-input alternative="" label="Type Code" disabled placeholder="" v-model="document_type.type_code" input-classes="form-control" required/>
                    <base-input alternative="" label="Friendly Code" disabled placeholder="" v-model="document_type.friendly_code" input-classes="form-control" required/>
                    <base-input alternative="" label="Name" disabled laceholder="" v-model="document_type.name" input-classes="form-control" required/>
                    <base-input alternative="" label="Table Prefix" disabled placeholder="" v-model="document_type.table_prefix" input-classes="form-control" required/>
                    <base-input alternative="" label="Party Table" disabled placeholder="" v-model="document_type.party_table" input-classes="form-control" required/>
                    <base-input alternative="" label="Party Field" disabled placeholder="" v-model="document_type.party_field" input-classes="form-control"/>
                    <base-input alternative="" label="Party Type" disabled placeholder="" v-model="document_type.party_type" input-classes="form-control"/>
                    <base-input alternative="" label="Price Fields" disabled placeholder="" v-model="document_type.price_fields" input-classes="form-control"/>
                    <base-input alternative="" label="Price Description" disabled placeholder="" v-model="document_type.price_descriptions" input-classes="form-control"/>
                    <base-input alternative="" label="Max Lines" disabled placeholder="" v-model="document_type.max_lines" input-classes="form-control"/>
                    <base-input alternative="" label="Child Trans Code" disabled placeholder="" v-model="document_type.child_trans_code" input-classes="form-control"/>
                    <base-input alternative="" label="Child Type Code" disabled placeholder="" v-model="document_type.child_type_code" input-classes="form-control"/>
                    <base-input alternative="" label="Child Trans Code 2" disabled placeholder="" v-model="document_type.child_trans_code2" input-classes="form-control"/>
                    <base-input alternative="" label="Child Type Code 2" disabled placeholder="" v-model="document_type.child_type_code2" input-classes="form-control"/>
                    <base-input alternative="" label="Remark">
                        <textarea rows="4" class="form-control" disabled v-model="inputRemark"/>
                    </base-input>
                </div>
                <div v-if="customFormMode == 2">
                    <!-- Override -->
                    <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="DocumentType" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
                </div>
                <div v-if="customFormMode == 3">
                    <!-- Append -->
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="Basic" key="1">
                            <base-input alternative="" label="Trans Code" disabled placeholder="" v-model="document_type.trans_code" input-classes="form-control" required/>
                            <base-input alternative="" label="Type Code" disabled placeholder="" v-model="document_type.type_code" input-classes="form-control" required/>
                            <base-input alternative="" label="Friendly Code" disabled placeholder="" v-model="document_type.friendly_code" input-classes="form-control" required/>
                            <base-input alternative="" label="Name" disabled laceholder="" v-model="document_type.name" input-classes="form-control" required/>
                            <base-input alternative="" label="Table Prefix" disabled placeholder="" v-model="document_type.table_prefix" input-classes="form-control" required/>
                            <base-input alternative="" label="Party Table" disabled placeholder="" v-model="document_type.party_table" input-classes="form-control" required/>
                            <base-input alternative="" label="Party Field" disabled placeholder="" v-model="document_type.party_field" input-classes="form-control"/>
                            <base-input alternative="" label="Party Type" disabled placeholder="" v-model="document_type.party_type" input-classes="form-control"/>
                            <base-input alternative="" label="Price Fields" disabled placeholder="" v-model="document_type.price_fields" input-classes="form-control"/>
                            <base-input alternative="" label="Price Description" disabled placeholder="" v-model="document_type.price_descriptions" input-classes="form-control"/>
                            <base-input alternative="" label="Max Lines" disabled placeholder="" v-model="document_type.max_lines" input-classes="form-control"/>
                            <base-input alternative="" label="Child Trans Code" disabled placeholder="" v-model="document_type.child_trans_code" input-classes="form-control"/>
                            <base-input alternative="" label="Child Type Code" disabled placeholder="" v-model="document_type.child_type_code" input-classes="form-control"/>
                            <base-input alternative="" label="Child Trans Code 2" disabled placeholder="" v-model="document_type.child_trans_code2" input-classes="form-control"/>
                            <base-input alternative="" label="Child Type Code 2" disabled placeholder="" v-model="document_type.child_type_code2" input-classes="form-control"/>
                            <base-input alternative="" label="Remark">
                                <textarea rows="4" class="form-control" disabled v-model="inputRemark"/>
                            </base-input>
                        </a-tab-pane>
                        <a-tab-pane tab="Custom Fields" key="2" forceRender>
                            <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="DocumentType" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </a-spin>
                <div v-if="this.$attrs.viewMode != true">
                    <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button v-if="(profileId == 0)" :disabled="buttonDisabled" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                        <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                    </div> 
                    <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                    </div> 
                </div>
            
            </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState } from 'vuex'
import moment from 'moment'
import Autocomplete from 'vuejs-auto-complete'
var component_x;  
export default {
    components: {
        DynamicForm, Autocomplete
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {
        this.spinning = true;
        this.buttonDisabled = true;
        var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
        this.documentTypeOptions = document_types
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Document Types?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
        if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }
        if(this.serverType == 'branch'){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        } else {
            if(this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].disabled = true;
                }
            }
        } 
        component_x = this
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'document_types/' + component_x.profileId, null)    
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.document_type = data
                    if(data["resolution_code"] != null){
                        const search = what => data["resolution_code"].find(element => element.account_id === what);
                        const found = search(secureStorage.getItem("accountId"));
                        if (found) {
                            component_x.document_type.resolution_code = found.resolution_code
                        } else {
                            component_x.document_type.resolution_code = ""
                        }
                    } else {
                        component_x.document_type.resolution_code = ""
                    }
                    
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                } 
            } 
        } 
        this.dynamicFormKey++;
        this.spinning = false;
        this.buttonDisabled = false;
    },
    data: function(){
        return {
            spinning: false,
            buttonDisabled: false,
            DocumentType: null,
            inputCode: '',
            inputName: '',
            inputRemark: '',
            inputGlCode: '',
            errors: [],
            documentTypeOptions: [],
            showDetails: true,
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',

            document_type: {},
            documentTypeName: '',
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            supplier: {},
            formErrors: [],
            defaultDocumentTypeDetails:{}
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.DocumentType
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.DocumentType = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        documentTypeEndpoint(input) {
            return this.endPoint + '/document_types?name=' + input;
        },
        getDocumentType (group) {
            this.documentTypeName = group.display;
            this.document_type.resolution_code = group.value;
        },
        formattedDisplay (result) {
            return result.name;
        },
        validateForm(){
            this.errors = []; 
            this.errors.push(ValidateField.required('Trans Code', this.document_type.resolution_code));
            this.errors.push(ValidateField.required('Trans Code', this.document_type.trans_code));
            this.errors.push(ValidateField.required('Type Code', this.document_type.type_code));
            this.errors.push(ValidateField.required('Friendly Code', this.document_type.friendly_code));
            this.errors.push(ValidateField.required('Name', this.document_type.name));
            this.errors.push(ValidateField.required('Table Prefix', this.document_type.table_prefix));
            this.errors.push(ValidateField.required('Party Table', this.document_type.party_table));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function() {
            if(!this.validateForm()) {
                this.buttonDisabled = true;
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'document_types', null, this.document_type)    
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
                this.spinning = false;
                this.buttonDisabled = false;
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                this.spinning = true;
                this.buttonDisabled = true;
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'document_types/' + this.profileId, null, this.document_type) 
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
                this.spinning = false;
                this.buttonDisabled = false;
            }
        },
    }
}
</script>

<style>
</style>
